import { ProColumns, ProTable } from '@ant-design/pro-components';
import EditIcon from '@mui/icons-material/Edit';
import { debounce } from '@mui/material';
import { Tooltip as AntdTooltip, Form, InputNumber, Modal, Select, Button as CustomButton } from 'antd';
import CustomProTable from 'base/ui/components/CustomTable';
import LoadingScreen from 'base/ui/components/LoadingScreen/loadingScreen';
import { observer } from 'mobx-react';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ShowMoreText from 'react-show-more-text';
import { toast } from 'react-toastify';
import { BC02, BC02PopupModel, PopUpDataDetail, workOrderPendingModel } from 'services/report_services';
import * as rootStore from 'stores/root_store';
import { formatNumber } from 'utils/formatHelper';
import { columnsTable1 } from '../columnsTable';
import { StatusColor } from '../productionPlan';

import type { DragEndEvent } from '@dnd-kit/core';
import { arrayMove } from '@dnd-kit/sortable';
import moment from 'moment';
import { IoArrowBackCircle } from 'react-icons/io5';
import { ROUTES } from 'base/routes/routes';
import { AiOutlineDownload } from 'react-icons/ai';

export function createProductionPlanViewDetails() {
  return observer(() => {
    // ============ Navigation =================/
    const navigate = useNavigate();
    //loading page when reload
    const [isLoading, setIsLoading] = useState(true);
    // OPEN POP UP DIALOG
    const [open, setOpen] = useState(false);
    //Get the ID param from the URL
    const { id } = useParams();

    // sự kiện nút sắp xếp bảng 2
    const [showSave, setShowSave] = useState(false);

    const [dataProduct, setDataProduct] = useState<BC02>();
    const [workOrderPendings, setWorkOrderPendings] = useState<workOrderPendingModel[]>([]);
    const [workOrderSelected, setWorkOrderSelected] = useState<workOrderPendingModel[]>([]);
    // data show in popup
    const [dataPopup, setDataPopup] = useState<BC02PopupModel>();

    // data dropdown máy truyền
    const [dataDropDown, setDataDropDown] = useState<
      {
        label: string;
        value: string;
      }[]
    >([]);

    const dataProd = rootStore.reportStore.EquipmentStatusReportResponse.data;
    const date = new Date().toLocaleDateString('en-GB');

    //handle cập nhật thay đổi thông tin =============================================================
    const handleChangeEquipCard = async (
      value: {
        value: string;
        label: string;
      }[],
      option:
        | {
            value: string;
            label: string;
          }
        | {
            value: string;
            label: string;
          }[],
      index: number,
    ) => {
      if (option && Array.isArray(option)) {
        const dataTemp = { ...dataPopup };
        dataTemp?.chiTiets?.splice(index, 1, {
          ...dataTemp.chiTiets[index],
          barcode: option.map((b) => ({
            barcodeName: b.label,
            equipmentCardId: b.value,
          })),
        });
        setDataPopup(dataTemp);
      } else {
      }
    };

    const [check, setCheck] = useState(false);

    useEffect(() => {
      (async () => {
        if (check) {
          await getDataBC02();
        }
      })();
    }, [check]);

    useEffect(() => {
      setIsLoading(true);
      const getProductionPlanbyId = async () => {
        await rootStore.reportPresenter.getEquipmentStatusById(rootStore.reportStore, { equipmentCardId: id });
        setIsLoading(false);
      };

      const getListEquipCard = async () => {
        getDataBC02();
        await rootStore.reportPresenter.getListEquipCard(rootStore.reportStore);

        const tempt = columnsSelected.filter((item) => item.dataIndex !== 'mayChuyenThucHien');
        tempt.shift();
        tempt.splice(0, 0, {
          title: 'Sắp xếp',
          dataIndex: 'orderIndex',
          key: 'orderIndex',
          width: 30,
          onCell: (_, index) => ({
            className: 'text-center',
          }),
          render(dom, entity, index) {
            return (
              <Form
                initialValues={{ orderIndex: dom === '-' ? undefined : dom }}
                onFinish={async (fieldsValue: any) => {
                  const orderIndex = fieldsValue['orderIndex'];
                  await rootStore.reportPresenter.sortRowBC02Selected(rootStore.reportStore, {
                    mths: [
                      {
                        id: entity.id,
                        orderIndex: orderIndex,
                      },
                    ],
                  });
                  setCheck(true);
                }}
              >
                <Form.Item name={'orderIndex'}>
                  <InputNumber disabled={!showSave} size="small" controls={false} className="!w-full" />
                </Form.Item>
              </Form>
            );
          },
        });
        // tempt.pop();
        setColumnsSelected(tempt);
      };
      getProductionPlanbyId();
      getListEquipCard();
    }, [showSave]);

    // get data dropdown danh sách máy/truyền công đoạn ========================================================
    const getListEquipCard = async (stepCode: string, value = '', index?: number) => {
      await rootStore.reportPresenter.getDropdownBC02(rootStore.reportStore, stepCode, value);
      if (rootStore.reportStore.BC02DropdownResponse.isSuccess) {
        const dataFilter = rootStore.reportStore.BC02DropdownResponse.data!.map((i) => {
          return {
            label: i.equipmentName,
            value: i.equipmentCardId,
          };
        });
        setDataDropDown(dataFilter);
      }
    };
    // debounce dropdown
    const debounceHandler = useCallback(debounce(getListEquipCard, 300), []);

    // hàm get data cho các table ===============================================================================
    const getDataBC02 = async () => {
      await rootStore.reportPresenter.getBC02(rootStore.reportStore, {
        equipmentCardId: id,
      });
      if (rootStore.reportStore.BC02Response.isSuccess) {
        setDataProduct(rootStore.reportStore.BC02Response.data);
        setWorkOrderPendings(rootStore.reportStore.BC02Response.data?.lsxDangCho || []);
        setWorkOrderSelected(rootStore.reportStore.BC02Response.data?.lsxDaChon || []);
      }
    };
    // =================================== HANDLE POPUP =========================================================
    const [confirmLoading, setConfirmLoading] = useState(false);
    // Hàm sử lí nút lưu
    const handleOk = async () => {
      setConfirmLoading(true);
      setTimeout(() => {
        setOpen(false);
        setConfirmLoading(false);
      }, 2000);
      await rootStore.reportPresenter.saveChooseEquipment(rootStore.reportStore, {
        mmths: dataPopup?.chiTiets!.map((item) => ({
          idRouting: item.id,
          equipmentCardId: item.barcode?.map((i) => i.equipmentCardId),
        })),
      });
      getDataBC02();
      if (rootStore.reportStore.SaveResponse.isSuccess) {
        toast.success(rootStore.reportStore.SaveResponse.message);
      } else {
        toast.error(rootStore.reportStore.SaveResponse.message);
      }
    };
    const handleCancel = () => {
      setOpen(false);
    };

    // HANDLE OPEN POP UP =======================================================================================
    const handleOnClickOpen = async (item: workOrderPendingModel) => {
      await rootStore.reportPresenter.getDataPopupBC02(rootStore.reportStore, item.lsxId);
      if (rootStore.reportStore.BC02PopupResponse.isSuccess) {
        setDataPopup(rootStore.reportStore.BC02PopupResponse.data);
      }
      setOpen(true);
    };

    // ==========================================================================================================
    // table 1
    // const columns1 = columnsTable1;
    // table head of drag table
    const columns: ProColumns[] = [
      // stt
      {
        title: 'STT',
        width: 25,
        dataIndex: 'stt',
        key: 'stt',
        fixed: 'left',
        className: 'text-center ',
        align: 'center',
      },
      // khách hàng
      {
        title: 'Khách hàng',
        width: 50,
        dataIndex: 'khachHang',
        key: 'khachHang',
      },
      // Loại LSX
      {
        title: 'Loại LSX',
        dataIndex: 'loaiLSX',
        key: 'loaiLSX',
        width: 35,
      },
      // lệnh sản xuất
      {
        title: 'LSX',
        width: 40,
        dataIndex: 'lsx',
        key: 'lsx',
        className: '',
        render: (text) => {
          return {
            props: {
              style: {
                fontWeight: 'bold',
              },
            },
            children: text,
          };
        },
      },
      // thành phẩm/bán thành phẩm
      {
        title: 'TP/BTP',
        dataIndex: 'tpbtp',
        key: 'tpbtp',
        width: 50,
        render: (text, record) => {
          return <AntdTooltip title={text}>{text}</AntdTooltip>;
        },
      },
      // Ngày yêu cầu có hàng in
      {
        title: 'Ngày YC có hàng in',
        width: 60,
        dataIndex: 'ngayYeuCauCoHangIn',
        key: 'ngayYeuCauCoHangIn',
        render(text, record) {
          return record.ngayYeuCauCoHangIn ? moment(record.ngayYeuCauCoHangIn).format('DD/MM/YYYY HH:mm') : '-';
        },
        onCell: (_, index) => ({
          className: 'text-center',
        }),
      },
      // Ngày hàng in về
      {
        title: 'Ngày hàng in về',
        width: 60,
        dataIndex: 'ngayHangInVe',
        key: 'ngayHangInVe',
        render(text, record) {
          return record.ngayHangInVe ? moment(record.ngayHangInVe).format('DD/MM/YYYY HH:mm') : '-';
        },
        onCell: (_, index) => ({
          className: 'text-center',
        }),
      },
      // Số SP/Tờ/Công đoạn
      {
        title: 'Số SP/Tờ/CĐ',
        width: 30,
        dataIndex: 'soSPToCongDoan',
        key: 'soSPToCongDoan',
        className: 'text-right',
        // render: (text, record) => {
        //   return formatNumber(record.soSPToCongDoan, 0);
        // },
      },
      // số lượng phát lệnh
      {
        title: 'SL phát lệnh',
        width: 30,
        dataIndex: 'slPhatLenh',
        key: 'slPhatLenh',
        className: 'text-right',
        render: (text) => {
          return formatNumber(Number(text), 0);
        },
      },
      // số lượng tờ(SP) qui đổi
      {
        title: 'SL tờ (SP) qui đổi',
        width: 40,
        dataIndex: 'soLuongToQuyDoi',
        key: 'soLuongToQuyDoi',
        className: 'text-right',
        render: (text, record) => {
          return formatNumber(record.soLuongToQuyDoi, 0);
        },
      },
      // đơn vị tính
      {
        title: 'ĐVT',
        width: 20,
        dataIndex: 'dvt',
        key: 'dvt',
        className: '',
      },
      // Thời gian giao hàng
      {
        title: 'TG giao hàng',
        width: 50,
        dataIndex: 'tgGiaoHang',
        key: 'tgGiaoHang',
        render(text, record) {
          return <>{record.tgGiaoHang ? moment(record.tgGiaoHang).format('DD/MM/YYYY HH:mm') : '-'}</>;
        },
        onCell: (_, index) => ({
          className: 'text-center',
        }),
      },
      // công đoạn
      {
        title: 'Công đoạn',
        dataIndex: 'congDoan',
        key: 'congDoan',
        width: 105,
      },
      // thứ tự công đoạn
      {
        title: 'Thứ tự CĐ',
        width: 30,
        dataIndex: 'thuTuCongDoan',
        key: 'thuTuCongDoan',
        className: 'text-right',
      },

      // hướng dẫn sản suất
      {
        title: 'Hướng dẫn SX',
        width: 70,
        dataIndex: 'hdsx',
        key: 'hdsx',
      },
      // NVL sử dụng
      {
        title: 'NVL sử dụng',
        width: 80,
        dataIndex: 'nvlSuDung',
        key: 'nvlSuDung',
      },
      // máy/truyền thực hiện
      {
        title: '',
        dataIndex: 'chucNang',
        key: 'chucNang',
        width: 15,
        render: (text, record) => {
          return (
            <>
              <EditIcon onClick={() => handleOnClickOpen(record)} className="!text-[15px] float-right" />
            </>
          );
        },
      },
      {
        title: 'Máy/Chuyền thực hiện',
        dataIndex: 'mayChuyenThucHien',
        key: 'mayChuyenThucHien',
        width: 70,
        fixed: 'right',
        className: 'whitespace-nowrap text-ellipsis overflow-hidden !py-1',
        render: (text, record) => {
          return (
            <>
              <AntdTooltip title={text}>{text}</AntdTooltip>
              <EditIcon onClick={() => handleOnClickOpen(record)} className="!text-[15px] float-right" />
            </>
          );
        },
      },
    ];
    // table in popup
    const columnsPopup: ProColumns[] = [
      // STT Công đoạn
      {
        title: 'STT Công đoạn',
        dataIndex: 'sttCongDoan',
        width: 150,
        align: 'center',
      },
      // STT Công đoạn
      {
        title: 'Công đoạn',
        dataIndex: 'tenCongDoan',
        width: 200,
      },
      // STT Công đoạn
      {
        title: 'Máy/Chuyền',
        dataIndex: 'mayChuyen',
        render: (_, record: PopUpDataDetail, index) => {
          return {
            props: {},
            children: (
              <Select
                className="!w-full"
                size="small"
                mode="multiple"
                showSearch
                value={
                  dataPopup?.chiTiets?.at(index)?.barcode?.length
                    ? dataPopup?.chiTiets
                        ?.at(index)
                        ?.barcode?.map((t) => ({ label: t.barcodeName, value: t.equipmentCardId }))
                    : []
                }
                options={dataDropDown}
                onFocus={async () => {
                  await getListEquipCard(record.congDoan);
                }}
                onBlur={() => {
                  setDataDropDown([]);
                }}
                allowClear
                onSearch={async (value) => {
                  // setDataDropDown([]);
                  await debounceHandler(record.congDoan, value, index);
                }}
                filterOption={false}
                onClear={() => {
                  const tempt = { ...dataPopup };
                  tempt?.chiTiets?.filter((item, idx) => {
                    if (idx === index) {
                      // item.barcodeName = undefined;
                      // item.equipmentCardId = undefined;
                      item.barcode = undefined;
                    }
                    return item;
                  });
                  setDataPopup(tempt);
                }}
                onChange={(value, option) => handleChangeEquipCard(value, option, index)}
              />
            ),
          };
        },
      },
    ];

    const [columnTable1, setColumnTable1] = useState<ProColumns[]>(columnsTable1);
    const [columnsSelected, setColumnsSelected] = useState(columns);
    const [columnsPending, setColumnsPending] = useState(columns);

    return (
      <div>
        <div className="w-full  py-3 px-5 relative">
          <div className="title text-center ">
            {isLoading && <LoadingScreen />}
            <span
              onClick={() => navigate(ROUTES.REPORTS.MACHINE_STATUS.LINK)}
              className="flex items-center text-xs text-primary cursor-pointer font-medium w-fit"
            >
              <IoArrowBackCircle className="mr-2 text-base text-gray-500" />
              Quay lại
            </span>
            <h3 className="text-md font-bold text-gray-800 mb-2 uppercase">
              KẾ HOẠCH SẢN XUẤT THEO MÁY MÓC / CHUYỀN SẢN XUẤT
            </h3>
            <span className="italic text-xs underline">Ngày : {date}</span>
            <CustomButton
              size="middle"
              loading={isLoading}
              onClick={() => {
                rootStore.reportPresenter.exportDataBC02({ equipmentCardId: id });
              }}
              className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1 !absolute top-[30px] right-5"
              type="primary"
            >
              <AiOutlineDownload className="block text-base" />
              <span className="block">Export Excel</span>
            </CustomButton>
          </div>

          {/* show detail */}
          <div className="w-full bg-white py-3 px-5 rounded ">
            <div className="w-full bg-white py-3 flex rounded">
              <div className="w-full px-0 py-2 lg:grid lg:grid-cols-8 flex flex-col mb-2 border border-neutral-300">
                {/* col 1 */}
                <div className="col-span-3">
                  {/* Tên máy/ Chuyền*/}
                  <div className="w-full sm:flex-row sm:items-center grid grid-cols-3 gap-x-10">
                    <label className="min-w-[150px] font-medium text-xl text-gray-500 sm:text-end ">
                      Tên máy/ Chuyền
                    </label>
                    <span className="col-span-2 min-h-[30px] font-medium text-gray-900 border-b border-gray-300 sm:ml-5 px-3 py-1 text-xl focus-visible:outline-none focus:border-blue-500 caret-blue-600">
                      {dataProduct && dataProduct?.tenMayChuyen}
                    </span>
                  </div>
                  {/* Công đoạn */}
                  <div className="w-full sm:flex-row  sm:items-center grid grid-cols-3 gap-x-10">
                    <label className="min-w-[150px] font-medium text-xl text-gray-500 sm:text-end ">Công đoạn</label>
                    <span className="col-span-2  min-h-[30px] font-medium text-gray-900 border-b border-gray-300 sm:ml-5 px-3 py-1.5 text-xl focus-visible:outline-none focus:border-blue-500 caret-blue-600">
                      <ShowMoreText lines={1} more="xem tiếp..." less="...ẩn bớt" expanded={false}>
                        {dataProduct && dataProduct?.congDoan}
                      </ShowMoreText>
                    </span>
                  </div>
                  {/* Trạng thái */}
                  <div className="w-full sm:flex-row  sm:items-center grid grid-cols-3 gap-x-10">
                    <label className="min-w-[150px] font-medium text-xl text-gray-500 sm:text-end ">Trạng thái</label>
                    <span
                      className={`
                      ${dataProduct && dataProduct?.trangThai === StatusColor.HD ? 'bg-green-500' : ''}
                  ${dataProduct && dataProduct?.trangThai === StatusColor.CM ? 'bg-[#FEF5AC]' : ''}
                  ${dataProduct && dataProduct?.trangThai === StatusColor.VS ? 'bg-[#C1EFFF]' : ''}
                  ${dataProduct && dataProduct?.trangThai === StatusColor.NM ? 'bg-[#FFB3B3]' : ''}
                  ${dataProduct && dataProduct?.trangThai === StatusColor.ET ? 'bg-white' : ''}
                      col-span-2  min-h-[30px] font-medium
                      text-gray-900 border-b border-gray-300
                      sm:ml-5 px-3 py-1.5 text-xl
                      focus-visible:outline-none focus:border-blue-500 caret-blue-600`}
                    >
                      {dataProduct && dataProduct?.trangThai}
                    </span>
                  </div>
                  {/* Lý do ngưng máy */}
                  <div className="w-full sm:flex-row  sm:items-center grid grid-cols-3 gap-x-10">
                    <label className="min-w-[150px] font-medium text-xl text-gray-500 sm:text-end ">
                      Lý do ngưng máy
                    </label>
                    <span className="col-span-2  min-h-[30px] font-medium text-gray-900 border-b border-gray-300 sm:ml-5 px-3 py-1.5 text-xl focus-visible:outline-none focus:border-blue-500 caret-blue-600">
                      <ShowMoreText lines={1} more="xem tiếp..." less="...ẩn bớt" expanded={false}>
                        {dataProduct && dataProduct?.lyDoNgungMay}
                      </ShowMoreText>
                    </span>
                  </div>
                </div>
                {/* col 2 */}
                <div className="col-span-3">
                  {/* Số công nhân đang đứng ca */}
                  <div className="w-full sm:flex-row sm:items-center grid grid-cols-3">
                    <label className="min-w-[150px] font-medium text-xl text-gray-500 sm:text-end ">
                      SL CN đứng ca
                    </label>
                    <span className="col-span-2 min-h-[30px] font-medium text-gray-900 border-b border-gray-300 sm:ml-5 px-3 py-1.5 text-xl focus-visible:outline-none focus:border-blue-500 caret-blue-600">
                      {dataProd?.quantityWorker}
                    </span>
                  </div>
                  {/* Thời gian bắt đầu */}
                  <div className="w-full sm:flex-row  sm:items-center grid grid-cols-3">
                    <label className="min-w-[150px] font-medium text-xl text-gray-500 sm:text-end ">
                      Thời gian bắt đầu
                    </label>
                    <span className="col-span-2 min-h-[30px] font-medium text-gray-900 border-b border-gray-300 sm:ml-5 px-3 py-1.5 text-xl focus-visible:outline-none focus:border-blue-500 caret-blue-600">
                      {dataProduct?.tgBatDau ? moment(dataProduct?.tgBatDau).format('DD/MM/YYYY HH:mm') : '-'}
                    </span>
                  </div>
                  {/* TG dự kiến hoàn thành */}
                  <div className="w-full sm:flex-row  sm:items-center grid grid-cols-3">
                    <label className="min-w-[150px] font-medium text-xl text-gray-500 sm:text-end ">
                      TG dự kiến hoàn thành
                    </label>
                    <span className="col-span-2 min-h-[30px] font-medium text-gray-900 border-b border-gray-300 sm:ml-5 px-3 py-1.5 text-xl focus-visible:outline-none focus:border-blue-500 caret-blue-600">
                      {dataProduct?.tgDuKienHoanThanh
                        ? moment(dataProduct?.tgDuKienHoanThanh).format('DD/MM/YYYY HH:mm')
                        : '-'}
                    </span>
                  </div>

                  {/*Ghi chú */}
                  <div className="w-full sm:flex-row  sm:items-center grid grid-cols-3">
                    <label className="min-w-[150px] font-medium text-xl text-gray-500 sm:text-end ">Ghi chú</label>
                    <span className="col-span-2 min-h-[30px] font-medium text-gray-900 border-b border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600">
                      <ShowMoreText lines={1} more="xem tiếp..." less="...ẩn bớt" expanded={false}>
                        {dataProd?.description}
                      </ShowMoreText>
                    </span>
                  </div>
                </div>
                {/* col 3 */}
                <div className="col-span-2 pl-10">
                  {/* Danh sách công nhân */}
                  <div className="w-full sm:flex-row  sm:items-center grid grid-cols-1">
                    <label className="min-w-[150px] font-medium text-lg text-gray-500 border-b text-center">
                      Danh sách công nhân
                    </label>
                    <div className="max-h-96 overflow-auto">
                      {dataProduct &&
                        dataProduct?.danhSachCongNhan?.map((item, index) => {
                          return (
                            <div
                              key={index}
                              className="col-span-2 min-h-[30px] font-medium text-gray-900 border-b border-gray-300 sm:ml-5 px-3 py-1.5 text-lg focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                            >
                              {item}
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
                {/* <CustomProTable
                  columns={columnTable1}
                  handleResize={handleResize}
                  rowKey="lsxDangThucHien"
                  bordered
                  options={false}
                  pagination={false}
                  search={false}
                  size="small"
                  dataSource={dataProduct?.lsxDangThucHien}
                  scroll={{ x: 1550, y: 500 }}
                  expandable={{
                    expandedRowKeys: dataProduct?.lsxDangThucHien
                      ? [...dataProduct?.lsxDangThucHien.map((i) => i.lsxDangThucHien + '')]
                      : [],
                    expandIcon: () => {
                      return <></>;
                    },
                  }}
                  className="col-span-8 mt-4 [&_.ant-table-tbody>tr>td]:!font-sans  [&_.ant-pro-card-body]:!p-0 [&_.ant-table-thead>tr>th]:!bg-[#1677FF] [&_.ant-table-thead>tr>th]:!text-white [&_.ant-table-thead>tr>th]:!font-bold"
                /> */}
                <div className="col-span-8">
                  <CustomProTable
                    handleResize={() => {}}
                    columns={columnTable1}
                    rowKey="lsxDangThucHien"
                    bordered
                    options={false}
                    pagination={false}
                    dataSource={dataProduct?.lsxDangThucHien}
                    className="[&_.ant-table-cell]:!p-1 [&_.ant-table-thead>tr>th]:text-[15px] mt-2"
                  />
                </div>
              </div>
            </div>
            {/* =========== Table PO ===============*/}
            <div>
              {/* các lệnh sản xuất đã chọn */}
              <div className="flex gap-4 mb-1 items-center text-xl">
                <h4 className="font-bold text-base">
                  Các LSX đang chờ thực hiện của máy/chuyền: {dataProduct && dataProduct?.tenMayChuyen}
                </h4>
                <CustomButton
                  type="primary"
                  onClick={(e) => {
                    if (showSave) {
                      // e.stopPropagation()
                      e.preventDefault();
                      const forms = document.querySelectorAll('form');
                      forms.forEach((form) => {
                        // Create a temporary hidden submit button
                        const hiddenSubmitButton = document.createElement('button');
                        hiddenSubmitButton.type = 'submit';
                        hiddenSubmitButton.style.display = 'none';
                        form.appendChild(hiddenSubmitButton);

                        hiddenSubmitButton.click(); // Trigger the submit action
                        form.removeChild(hiddenSubmitButton); // Clean up
                      });
                      setShowSave(!showSave);
                    } else {
                      setShowSave(!showSave);
                    }
                  }}
                >
                  {showSave ? 'Lưu' : 'Sắp xếp'}
                </CustomButton>
              </div>
              <CustomProTable
                handleResize={() => {}}
                columns={columnsSelected}
                rowKey="stt"
                bordered
                options={false}
                pagination={false}
                dataSource={workOrderSelected}
                className="[&_.ant-table-cell]:!p-1 [&_.ant-table-thead>tr>th]:text-[15px]"
              />
              {/* các lệnh sản xuất đang chờ */}
              <div className="flex justify-between mt-2">
                <h4 className="font-bold text-base">
                  Các LSX có công đoạn {dataProduct && dataProduct?.congDoan} chưa chọn máy/chuyền
                </h4>
              </div>
              <CustomProTable
                handleResize={() => {}}
                columns={columnsPending.filter(
                  (column) =>
                    column.dataIndex !== 'thuTuCongDoan' &&
                    column.dataIndex !== 'hdsx' &&
                    column.dataIndex !== 'nvlSuDung' &&
                    column.dataIndex !== 'soSPToCongDoan' &&
                    column.dataIndex !== 'soLuongToQuyDoi' &&
                    column.dataIndex !== 'chucNang',
                )}
                rowKey="stt"
                bordered
                options={false}
                pagination={false}
                dataSource={workOrderPendings}
                className="[&_.ant-table-cell]:!p-1 [&_.ant-table-thead>tr>th]:text-[15px]"
              />
            </div>
          </div>
        </div>

        {/* modal antd */}
        <>
          <Modal
            title={
              <div className="flex flex-col">
                <div className="text-lg text-center uppercase text-[#1677FF]">Chọn máy thực hiện</div>
                <span className="w-full bg-black h-[2px]"></span>
              </div>
            }
            open={open}
            onOk={handleOk}
            okText="Lưu" // Nhãn mới cho nút Submit
            confirmLoading={confirmLoading}
            width={1000}
            onCancel={handleCancel}
            style={{
              borderRadius: 0,
            }}
          >
            <p className="font-bold text-base mb-3">Lệnh sản xuất: {dataPopup?.lsx}</p>
            <ProTable
              columns={columnsPopup}
              rowKey="sttCongDoan"
              bordered
              scroll={{ x: 900, y: 300 }}
              size="small"
              pagination={false}
              dataSource={dataPopup?.chiTiets}
              search={false}
              options={false}
              className="[&_.ant-table-tbody>tr>td]:!font-sans  [&_.ant-pro-card-body]:!p-0 [&_.ant-table-thead>tr>th]:!bg-[#1677FF] [&_.ant-table-thead>tr>th]:!text-white [&_.ant-table-thead>tr>th]:!font-bold"
            />
          </Modal>
        </>
      </div>
    );
  });
}
